import { Button, PageHeader } from 'components';
import { Spin, Table } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ShowError from 'components/showError';
import { useEditCalendar } from './useEditCalendar';
import styles from './style.module.scss';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { singleData, columns, loading, onSubmit, errors } = useEditCalendar();
  const title = isNew ? t('CREARE Footfall & Calendar').toUpperCase() : t('MODIFICA Footfall & Calendar').toUpperCase();

  const handleCreate = () => {
    onSubmit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <ShowError errors={errors} type={'alert'} />
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={singleData}
            loading={loading}
            pagination={false}
            scroll={{ x: 1000 }}
          />
        </Spin>
        <Button
          onClick={handleCreate}
          loading={loading}
          width={'150px'}
          style={{ marginTop: 30 }}
          big
          icon={<CheckOutlined />}
        >
          {t('Invia')}
        </Button>
      </div>
    </div>
  );
};

export default Edit;
